/**
 * 流媒体websocket工具类，提供websocket连接、自动重连、发送消息、消息响应hook、枚举常量等基础能力
 */
import { warning, getSession } from '@/api/common'
import store from '@/store/index'
import { errorCollection } from '@/api/dmp/dmpCollection'
import i18n from '@/common/i18n'

/**
 * 安全帽掉线处理逻辑
 * @param {String} peerId 房间用户id，安全帽的格式为ms_userid，例如ms_288
 */
let userHelmetLeave = function(peerId) {
  // leaveRoomSelf()
}

/**
 * 外部设置 安全帽掉线处理逻辑
 * @param {Function} callback 安全帽掉线处理逻辑
 */
function setUserHelmetLeave(callback) {
  userHelmetLeave = callback
}
let websocketapp = {
  existHelmetIds: [],

  // 安全帽操作外部action

  /**
   * 错误=-1
   */
  ERROR: -1,
  /**
   * 其他操作=0
   */
  OTHER: 0,
  /**
   * 客户端保持心跳=1
   */
  KEEPALIVE: 1,
  /**
   * 绑定安全帽=2
   */
  UTARGET: 2,
  /**
   * 控制安全帽=3
   */
  CONTROL: 3,
  /**
   * 安全帽状态=4
   */
  HSTATUS: 4,
  /**
   * 在线安全帽=5
   */
  QTARGETS: 5,
  /**
   * 安全帽列表=6
   */
  HELMETS: 6,
  /**
   * 是否在线=7
   */
  ISONLINE: 7,
  /**
   * 一键求助=8
   */
  EMERGHELP: 8,
  /**
   * 求助是否已处理=9
   */
  ISHELPED: 9,
  /**
   * 安全帽操作响应=10
   */
  HELMET_OPERATION: 10,
  /**
   * 注册=11
   */
  REGISTER: 11,
  /**
   * 语音对讲=12
   */
  WALKIE: 12,

  /**
   * 和后端的 WebSocketMsg 消息交互模型对象保持一致
   * @param {Object} action 安全帽操作外部action
   * @param {Object} helmetId 安全帽序列号
   * @param {Object} msg 传递消息
   */
  WebSocketMsg: function(action, helmetId, msg) {
    this.action = action
    this.helmetId = helmetId
    this.msg = msg
  },

  /**
   * 和后台的遥控指令对象保持一致
   * @param {Object} operationType
   * @param {Object} operationCode
   */
  HelmetControl: function(operationType, operationCode) {
    this.operationType = operationType
    this.operationCode = operationCode
  },

  /**
   * netty消息的封装
   * @param {Object} header
   * @param {Object} content
   */
  Msg: function(header, content) {
    this.header = header
    this.content = content
  },

  /**
   * netty消息头的封装
   * @param {Object} from
   * @param {Object} to
   */
  MsgHeader: function(from, to) {
    this.from = from
    this.to = to
  },

  /**
   * netty消息体的封装
   * @param {Object} cmd
   * @param {Object} params
   * @param {Object} code
   * @param {Object} errorMsg
   */
  MsgContent: function(cmd, params, code, errorMsg) {
    this.cmd = cmd
    this.params = params
    this.code = code
    this.errorMsg = errorMsg
  },
}

/**
 * 请求动作常量
 */
const ACION_REQUEST = {
  /**
   * 加入房间=0
   */
  JION_ROOM: 0,
  /**
   * 退出房间=1
   */
  EXIT_ROOM: 1,
  /**
   * 切换分辨率=2
   */
  SWITCH_RESOLUTION: 2,
  /**
   * 控制video 声音='3'
   */
  CONTROL_VOLUME: 3,
  /**
   * 抢占视频
   */
  GRAB_VIDEO: 4,
  /**
   * 拍照
   */
  VIDEO_PHOTO: 5,
  /**
   * 直播=11
   */
  LIVE: 11,
}

/**
 * 清晰度常量
 */
const RESOLUTION = {
  /**
   * 流畅 640*360, 推荐码率：200kbps
   */
  RESOLUTION_180P: 10,
  /**
   * 标清 720*480, 推荐码率：500kbps
   */
  RESOLUTION_480P: 12,
  /**
   * 高清 1280*720, 推荐码率：1mbps
   */
  RESOLUTION_720P: 14,
  /**
   * 高清 1920*1080, 推荐码率：1mbps
   */
  RESOLUTION_1080P: 16,
}

let isUserSend = false
/**
 * 一键求助响应处理
 */
let isWalkie = function() {}
/**
 * 接收到一键求助时外部函数处理
 */
function setIsWalkieResponse(callback) {
  isWalkie = callback
}

/**
 * 一键求助响应处理
 */
let emergencyHelp = function() {}
/**
 * 接收到一键求助时外部函数处理
 */
function setEmergencyHelpResponse(callback) {
  emergencyHelp = callback
}
/**
 * 求助是否已处理
 */
let isHelped = function() {}
/**
 * 求助是否已处理外部处理函数
 */
function setIsHelpedResponse(callback) {
  isHelped = callback
}
/**
 * 安全帽操作响应处理
 */
let handleHelmetOperationResponse = function() {}

/**
 * 外部设置 安全帽操作响应处理
 * @param {Function} callback 安全帽操作响应处理函数
 */
function setHandleHelmetOperationResponse(callback) {
  handleHelmetOperationResponse = callback
}

// 接收安全帽状态hook
let recevieHelmetStatus = function() {}

/**
 * 收到安全帽状态时候外部函数处理
 * @param {*} callback 回调函数
 */
function setRecevieHelmetStatus(callback) {
  recevieHelmetStatus = callback
}
let userNet = false
let userHelmetId
/**
 * websocket 封装
 */
let CHAT = {
  socket: null,
  keepaliveInterval: null,
  /**
   * 动作类型
   */
  doActionType: -1,
  helpId: null,
  // 设置连接地址
  url: '',
  /**
   * websocket 初始化连接
   */
  init: function() {
    // 用window.WebSocket判断浏览器是否支持WebSocket协议
    if (window.WebSocket) {
      // 如果当前的状态已经连接，那就不需要重复初始化websocket
      if (CHAT.socket && CHAT.socket.readyState === WebSocket.OPEN) {
        return false
      }
      CHAT.socket = new WebSocket(CHAT.url)
      CHAT.socket.onopen = CHAT.wsopen
      CHAT.socket.addEventListener('message', CHAT.wsmessage)
      CHAT.socket.onclose = CHAT.wsclose
      CHAT.socket.onerror = CHAT.wserror
    } else {
      warning(i18n.t('browserDoeSupport'))
      errorCollection('系统异常', '系统异常', {
        status: 200,
        data: { state: -1, msg: '浏览器不支持websocket协议', operationType: 'SYSTEM_ERROR' },
      })
    }
  },

  /**
   * websocket 发送消息
   * @param {*} action 动作id
   * @param {*} helmetId 设备序列号
   * @param {Object} msg 消息内容,json对象
   */
  chat: function(action, helmetId, msg) {
    var wsMsg = new websocketapp.WebSocketMsg(action, helmetId, JSON.stringify(msg))
    if (action === 10) {
      store.commit('userSend', true)
    }
    var data = JSON.stringify(wsMsg)
    // 如果当前websocket的状态是已打开，则直接发送
    if (CHAT.socket !== null && CHAT.socket !== undefined && CHAT.socket.readyState === WebSocket.OPEN) {
      CHAT.socket.send(data)
      if (action === 3) {
        userNet = true
        userHelmetId = helmetId
      }
    } else {
      if (action !== websocketapp.KEEPALIVE) {
        clearInterval(CHAT.keepaliveInterval)
        // setTimeout(CHAT.init(), 3000)
        // 重连后重新发送消息
        setTimeout("CHAT.reChat('" + data + "')", '1000')
      }
    }
  },

  /**
   * 重新发送消息
   * @param {*} msg 发送的消息
   */
  reChat: function(msg) {
    CHAT.socket.send(msg)
  },

  /**
   * 连接成功事件
   */
  wsopen: function() {
    console.log('remote websocket连接已建立')
    // 注册前先判断用户是否token还在
    CHAT.chat(websocketapp.REGISTER, '', {
      content: {
        cmd: 'REGISTER',
        code: '000',
        params: {
          clientType: 'SYSCONTROL',
          clientName: getSession('userId'),
          tenantId: getSession('tenantId'),
        },
      },
      header: {
        from: getSession('userId'),
        requireResponse: false,
        to: 'SYS',
      },
    })
    // 定时发送心跳
    if (CHAT.keepaliveInterval != null) {
      clearInterval(CHAT.keepaliveInterval)
    }
    CHAT.keepaliveInterval = setInterval(() => {
      CHAT.keepalive()
    }, 10000)
  },

  /**
   * 接受服务器消息处理
   * @param {*} e 接受到的响应参数
   */
  wsmessage: function(e) {
    // e.data结构： {"action":10,"msg":"{\"content\":{\"cmd\":\"COMMUNICATION\",\"code\":\"000\",\"params\":{\"helmetId\":\"HW02100179\",\"cloudroomType\":\"4\",\"status\":\"{\\\"roomId\\\":0,\\\"stopEventType\\\":0,\\\"action\\\":4}\"}},\"header\":{\"from\":\"管控3租户\",\"requireResponse\":false,\"to\":\"HW02100179\"}}"}
    // 第一层：{"action":10,"msg":""}
    // 第二层：msg = {"content":{"params":{"status":""}}}
    // 第三层：status = {"action": 4}
    if (!e.data) {
      console.error('参数错误')
      errorCollection('系统异常', '系统异常', {
        status: 200,
        data: { state: -1, msg: 'websocket接收消息参数错误', operationType: 'SYSTEM_ERROR' },
      })
      return
    }
    var receiveData = JSON.parse(e.data)
    if (!receiveData.msg) {
      console.error('参数错误')
      errorCollection('系统异常', '系统异常', {
        status: 200,
        data: { state: -1, msg: 'websocket接收消息参数错误', operationType: 'SYSTEM_ERROR' },
      })
      return
    }
    var receiveMsg = null
    try {
      receiveMsg = JSON.parse(receiveData.msg)
    } catch (error) {
      console.error(receiveData.msg, error)
      return
    }
    if (store.state.openVedio && userNet === true && store.state.isUserSend) {
      userNet = false
    }
    var receiveParams = receiveMsg.content.params
    // console.log(receiveData,"receiveData324234")
    switch (receiveData.action) {
      case -2:
        // 注册失败关闭连接
        CHAT.close()
        break
      case websocketapp.ERROR:
        console.error('操作有误')
        errorCollection('系统异常', '系统异常', {
          status: 200,
          data: { state: -1, msg: 'websocket消息错误', operationType: 'SYSTEM_ERROR' },
        })
        break
      case websocketapp.OTHER:
        errorCollection('系统异常', '系统异常', {
          status: 200,
          data: { state: -1, msg: 'websocket消息错误', operationType: 'SYSTEM_ERROR' },
        })
        console.error('操作有误')
        errorCollection('系统异常', '系统异常', {
          status: 200,
          data: { state: -1, msg: 'websocket消息错误', operationType: 'SYSTEM_ERROR' },
        })
        break
      case websocketapp.HSTATUS:
        // 接收到遥控器状态信息
        recevieHelmetStatus(receiveMsg, receiveParams)
        break
      case websocketapp.HELMETS:
        // updateOnlineHelmets(e.data) //在线安全帽
        break
      case websocketapp.EMERGHELP:
        if (
          !window.location.href.includes('/Intercom') &&
          !window.location.href.includes('/realvideo') &&
          !window.location.href.includes('/externalHistory') &&
          !window.location.href.includes('/monitor') &&
          !window.location.href.includes('/Login')
        ) {
          emergencyHelp(receiveData, receiveParams)
        }
        break
      case websocketapp.ISHELPED:
        isHelped(receiveData, receiveParams)
        break
      case websocketapp.HELMET_OPERATION:
        setTimeout(() => {
          handleHelmetOperationResponse(receiveParams)
        }, 300)
        break
      case websocketapp.WALKIE:
        isWalkie(receiveData, receiveParams)
        break
      default:
        break
    }
  },
  wsclose: function(e) {
    clearInterval(CHAT.keepaliveInterval)
    CHAT.socket.close()
    if (e && e.code === 1006) {
      // 非正常关闭重连
      if(linkTime < 30) {
        linkTime++ 
        setTimeout(() => {
          CHAT.init()
        }, 1000)
      }
    }
    console.info('remote websocket连接关闭...')
  },
  wserror: function() {
    console.error('websocket error')
  },
  keepalive: function() {
    CHAT.chat(websocketapp.KEEPALIVE, '', '')
  },
}

// websocket连接
if (window.location.host.includes('localhost:808')) {
  // 不要在这里直接修改CHAT.url的值！！！
  // 本地环境访问地址，若想切换环境参考 .env 文件中的说明新建一个不会提交的配置文件
  // 不要在这里直接修改CHAT.url的值！！！
  CHAT.url = process.env.VUE_APP_WS_ROMETE
} else if (window.location.protocol === 'http:') {
  CHAT.url = 'ws://' + window.location.host + '/remote/websocket'
} else {
  CHAT.url = 'wss://' + window.location.host + '/remote/websocket'
}

export const creatGK3Socket = () => {
  CHAT.init()
}

// websocket
export { CHAT, websocketapp, ACION_REQUEST, RESOLUTION }

// 安全帽操作响应处理
export { setHandleHelmetOperationResponse }

// 安全帽状态响应处理
export { setRecevieHelmetStatus }

// 一键求助响应处理
export { setEmergencyHelpResponse }

// 对讲处理
export { setIsWalkieResponse }

// 求助是否已经处理
export { setIsHelpedResponse }
export { setUserHelmetLeave }
